<template>
  <div class="navigation-buttons">
    <FriedButton
      class="navigation-button"
      data-external="dsr-goto-previous-page-button"
      :disabled="!previousPageId"
      @click="$emit('goto-page', previousPageId)"
      ><span class="navigation-button-text">{{ t('dsr_previous_page') }}</span></FriedButton
    >
    <FriedButton
      class="navigation-button"
      data-external="dsr-goto-next-page-button"
      :disabled="!nextPageId"
      @click="$emit('goto-page', nextPageId)"
      ><span class="navigation-button-text">{{ t('dsr_next_page') }}</span></FriedButton
    >
  </div>
</template>
<script lang="ts">
import { useI18n } from 'vue-i18n';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'NavigationButtons',
  props: {
    nextPageId: {
      type: String,
      default: '',
    },
    previousPageId: {
      type: String,
      default: '',
    },
  },
  emits: ['goto-page'],
  setup() {
    const { t } = useI18n();
    return { t };
  },
});
</script>
<style lang="scss" scoped>
.navigation-buttons {
  display: flex;
  gap: var(--spacing-100);
  margin-top: 2.5rem;
  padding: 0 var(--spacing-100) var(--spacing-100) var(--spacing-100);

  :deep(.navigation-button .button-text) {
    max-width: 100%;
  }

  .navigation-button {
    flex: 1;

    .navigation-button-text {
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
